import { render, staticRenderFns } from "./MusicContributorManager.vue?vue&type=template&id=15e40f5c&"
import script from "./MusicContributorManager.vue?vue&type=script&lang=js&"
export * from "./MusicContributorManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports